import { StateSchema } from 'app/config/storeConfig/types';

export const getVertexEditShapeId = (state: StateSchema): Nullable<string> => state.warehouseMapConstructor.vertexEditShapeId;
